import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 16px;

  @media (min-width: ${props => props.theme.screen.xs}) {
    max-width: 540px;
  }

  @media (min-width: ${props => props.theme.screen.sm}) {
    max-width: 720px;
  }

  @media (min-width: ${props => props.theme.screen.md}) {
    padding: 0 40px;
    max-width: 1360px;
  }

  ${props =>
    props.fluid &&
    `
    max-width: 1360px !important;
  `};
`;

export const Section = styled.section`
  overflow: hidden;
  padding: 8rem 0;

  @media (max-width: ${props => props.theme.screen.md}) {
    padding: 4rem 0;
  }
`;

export const Input = styled.input`
  background: none;
  border: none;
  outline: none;
  padding: 0;

  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.5rem 0;
  width: 100%;
  color: ${props => props.theme.color.white.dark};

  &::placeholder {
    color: ${props => props.theme.color.white.regular};
    opacity: 0.3;
  }
`;

export const Button = styled.button`
  ${props => props.theme.font_size.regular};
  background-color: ${props =>
    !props.secondary
      ? props.theme.color.blue[1].dark
      : props.theme.color.blue[3].dark};
  color: ${props => props.theme.color.white.regular};
  text-align: left;
  padding: 0.5rem 1rem;
  width: 100%;
  border-radius: 2px;
  box-shadow: 0px 2.51154px 2.51154px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;

  @media (max-width: ${props => props.theme.screen.md}) {
    ${props => props.theme.font_size.small};
    padding: 0.75rem 1.25rem;
  }

  svg {
    transition: transform 0.1s ease-out;
  }

  &:hover:not(:disabled) {
    box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.05);

    > svg {
      transform: translateX(2px);
    }
  }

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;

export const BlurredBg = styled.div`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: ${props => props.theme.color.blue.bg};
    filter: blur(200px);
    z-index: -100;
  }
`;
